import { useSelector } from "react-redux"
import { Circle, CircleMembership, UserCircleInfo } from "./circle.types"
import { CircleAccessRequest, Invitations } from "lib-core"


export const selectCircleUserInfo = (state): UserCircleInfo => {
    const { group, membership, invitation } = state.group?.value || ({} as any)
    return {
        group,
        membership,
        invitation,
    }
}
export interface ApiListOld<T, E = any> {
    map: Record<string, T>
    list: {
        values: string[]
    }
    extra: E
}

export const selectAccessRequests = (state): CircleAccessRequest[] => {
    const requestsInfo: ApiListOld<CircleAccessRequest> = state.access_requests
    const ids = requestsInfo?.list?.values
    if (!ids) {
        return []
    }

    const requests = ids.map(id => requestsInfo.map[id])

    return requests
}

export const useCircleAccessRequest = (): CircleAccessRequest[] => {
    return useSelector(selectAccessRequests)
}

export const useCircleUserInfo = () => {
    return useSelector(selectCircleUserInfo)
}

export const selectCircle = (state): Circle => {
    return state.group?.value?.group
}

export const useCircle = () => {
    return useSelector(selectCircle)
}


export const selectCircleMembership = (state): CircleMembership => {
    return state.group?.value?.membership
}

export const useCircleMembership = () => {
    return useSelector(selectCircleMembership)
}